export default {
    lang: 'chinses/english',
    navList: {
        page: 'index',
        about: 'aboutUs'
    }
}